// Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyBBR0YG37st-xA7BHU2OtVAz3KZb8kgOVI",
  // Use custom domain for authDomain to prevent sessionStorage issues with redirects
  // This ensures sessionStorage is preserved during OAuth redirects
  authDomain: window.location.hostname === 'solarfi.us' || window.location.hostname === 'www.solarfi.us' 
    ? "solarfi.us" 
    : "solarify-d8f9d.firebaseapp.com",
  projectId: "solarify-d8f9d",
  storageBucket: "solarify-d8f9d.firebasestorage.app",
  messagingSenderId: "642920895062",
  appId: "1:642920895062:web:29fbe164faa6fa363021f7",
  measurementId: "G-751L771PZK"
}

export const googleMapsConfig = {
  apiKey:
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
    process.env.REACT_APP_GOOGLE_PLACES_API_KEY ||
    ''
}

// Development environment check
if (process.env.NODE_ENV === 'development') {
  console.log('🔥 Firebase Config Loaded for Development')
  console.log('📝 Auth Domain:', firebaseConfig.authDomain)
  console.log('⚠️  Make sure to add "localhost" to Firebase Console → Authentication → Settings → Authorized domains')
} 